import { log } from '@ms-ows/logging'

import {
  FabricDependencies,
  getFabricDependencies,
} from '../fabric-dependencies'
import { initializeIcons } from '../icons'
import { FetchCorsMode, MultiSurfaceParams, SurfaceParams } from '../models'

import { isMultiSurfaceParams } from './helpers'

let iconsLoaded = false

export const initializeFabricIcons = (
  fabricDependencies: FabricDependencies
) => {
  if (!iconsLoaded) {
    initializeIcons(fabricDependencies, undefined, { disableWarnings: true })
    iconsLoaded = true
  }
}

const preloadImage = (imageSrc: string, imageFetchCorsMode: FetchCorsMode) => {
  if (imageSrc && !imageSrc.startsWith('data:image')) {
    if (window.fetch) {
      window
        .fetch(imageSrc, { mode: imageFetchCorsMode || 'no-cors' })
        .catch((error: Error) =>
          log.error(
            0x23602890 /* tag_9yc8q */,
            'failed to pre fetch image',
            imageSrc,
            // tslint:disable-next-line: no-unsafe-any
            error && error.message
          )
        )
    } else {
      const img = new Image()
      img.src = imageSrc
    }
  }
}

const preloadImages = (surfaceParams: MultiSurfaceParams | SurfaceParams) => {
  if (isMultiSurfaceParams(surfaceParams)) {
    const illustrationImageKey: keyof SurfaceParams = 'illustrationImage'
    for (const key of Object.keys(surfaceParams)) {
      if (key.startsWith(illustrationImageKey)) {
        preloadImage(
          surfaceParams[key] as string,
          surfaceParams.imageFetchCorsMode as FetchCorsMode
        )
      }
    }
  } else {
    surfaceParams.illustrationImage &&
      preloadImage(
        surfaceParams.illustrationImage,
        surfaceParams.imageFetchCorsMode
      )
  }
}

export const preloadResources = (
  surfaceParams: MultiSurfaceParams | SurfaceParams
) => {
  preloadImages(surfaceParams)

  const fabricDependencies = getFabricDependencies()

  if (fabricDependencies) {
    initializeFabricIcons(fabricDependencies)
  }
}
